import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_13 = { class: "control-label col-sm-6" }
const _hoisted_14 = { class: "col-sm" }
const _hoisted_15 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_16 = { class: "control-label col-sm-6" }
const _hoisted_17 = { class: "col-sm" }
const _hoisted_18 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_19 = { class: "control-label col-sm-6" }
const _hoisted_20 = { class: "col-sm" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_23 = { class: "control-label col-sm-6" }
const _hoisted_24 = { class: "col-sm" }
const _hoisted_25 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_26 = { class: "control-label col-sm-6" }
const _hoisted_27 = { class: "col-sm" }
const _hoisted_28 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_29 = { class: "control-label col-sm-6" }
const _hoisted_30 = { class: "col-sm" }
const _hoisted_31 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_32 = { class: "control-label col-sm-6" }
const _hoisted_33 = { class: "col-sm" }
const _hoisted_34 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_35 = { class: "control-label col-sm-6" }
const _hoisted_36 = { class: "col-sm" }
const _hoisted_37 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_38 = { class: "control-label col-sm-6" }
const _hoisted_39 = { class: "col-sm" }

import { ref, watch , inject} from 'vue';
import { usePreventivo } from '../../composable/usePreventivo'
import FormImmobiliareHelper from "./../../pages/preventivi/json/immobiliare/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormImmobiliareBeniCulturali',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo','infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categoriaImmobiliare
} = usePreventivo();
const props = __props;
const testoInfoCompilazione = ref([]);
const emits = __emit;
let validazione;
const validazioneEquoCompenso = ref();
const { regimeFiscale } = inject('regimeFiscale')
function secondaCasaSelezionato (event) {
  // Alla selezione di seconda casa, DL 73 non è più obbligatorio e ritenuta è ancora abilitato
  if (event.target.checked) {
    validazione.detrazione_credito_imposta.value = '';
  }
}
switch (props.formName) {
  case 'comprevenditaDiBeniCulturaliPrimoAttoSottopostoCondizione':
    validazione = categoriaImmobiliare['sottocategoriaBeniCulturali']['comprevenditaDiBeniCulturaliPrimoAttoSottopostoCondizione'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaBeniCulturali']['comprevenditaDiBeniCulturaliPrimoAttoSottopostoCondizione'];
    break
  case 'comprevenditaDiBeniCulturaliSecondoAttoAvveramentoSoggettoIva':
    validazione = categoriaImmobiliare['sottocategoriaBeniCulturali']['comprevenditaDiBeniCulturaliSecondoAttoAvveramentoSoggettoIva'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaBeniCulturali']['comprevenditaDiBeniCulturaliSecondoAttoAvveramentoSoggettoIva'];
    break
  case 'comprevenditaDiBeniCulturaliSecondoAttoAvveramentoRegistro':
    validazione = categoriaImmobiliare['sottocategoriaBeniCulturali']['comprevenditaDiBeniCulturaliSecondoAttoAvveramentoRegistro'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaBeniCulturali']['comprevenditaDiBeniCulturaliSecondoAttoAvveramentoRegistro'];
    break
}
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'immobiliare/beni_culturali/' + props.tipoPreventivo.data.url
}
testoInfoCompilazione.value =  FormImmobiliareHelper.sottocategoriaBeniCulturali[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
let indexHelperClosing = {
 calcolo:FormImmobiliareHelper.sottocategoriaBeniCulturali[props.formName],
 dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni 
}
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo');
}, { deep: true })

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'comprevenditaDiBeniCulturaliPrimoAttoSottopostoCondizione')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).prezzo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_input_text, {
                id: "prezzo",
                name: "prezzo",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).prezzo,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).prezzo) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                isSelected: _unref(validazione).forma_del_titolo.value != '',
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20 crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "prezzo",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'comprevenditaDiBeniCulturaliSecondoAttoAvveramentoSoggettoIva')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_13, [
                _createTextVNode(_toDisplayString(_unref(validazione).prezzo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo.ref]
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_base_input_text, {
                  id: "prezzo",
                  name: "prezzo",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).prezzo,
                  "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).prezzo) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_16, [
                _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_preliminare.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_preliminare.ref]
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_base_input_text, {
                  id: "detrazione_credito_preliminare",
                  name: "detrazione_credito_preliminare",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).detrazione_credito_preliminare,
                  "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).detrazione_credito_preliminare) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            (_unref(regimeFiscale) == 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20 crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "prezzo",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : (__props.formName === 'comprevenditaDiBeniCulturaliSecondoAttoAvveramentoRegistro')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_unref(validazione).prezzo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo.ref]
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_base_input_text, {
                    id: "prezzo",
                    name: "prezzo",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).prezzo,
                    "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).prezzo) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_26, [
                  _createTextVNode(_toDisplayString(_unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendite_prima_casa_e_pertinenze_agevolabili.ref]
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_base_input_text, {
                    id: "rendite_prima_casa_e_pertinenze_agevolabili",
                    name: "rendite_prima_casa_e_pertinenze_agevolabili",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili,
                    "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_29, [
                  _createTextVNode(_toDisplayString(_unref(validazione).rendite_e_pertinenze_non_agevolabili.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendite_e_pertinenze_non_agevolabili.ref]
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_base_input_text, {
                    id: "rendite_e_pertinenze_non_agevolabili",
                    name: "rendite_e_pertinenze_non_agevolabili",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).rendite_e_pertinenze_non_agevolabili,
                    "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).rendite_e_pertinenze_non_agevolabili) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_imposta.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_imposta.ref]
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_base_input_text, {
                    id: "detrazione_credito_imposta",
                    name: "detrazione_credito_imposta",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).detrazione_credito_imposta,
                    "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).detrazione_credito_imposta) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_35, [
                  _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_preliminare.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_preliminare.ref]
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_base_input_text, {
                    id: "detrazione_credito_preliminare",
                    name: "detrazione_credito_preliminare",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).detrazione_credito_preliminare,
                    "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).detrazione_credito_preliminare) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              (_unref(regimeFiscale) == 'ordinario')
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_38, [
                      _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_base_input_checkbox, {
                        class: _normalizeClass(props.disabilita ? 'crm:opacity-20 crm:pointer-events-none':''),
                        name: "ritenuta_acconto",
                        label: "Si, applicabile",
                        "validate-to": _unref(validazione).ritenuta_acconto,
                        "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                      }, null, 8 /* PROPS */, ["class", "validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(RegimeFiscale, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(AliquoteContributiRepertoriali, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(CalcoloEquoCompenso, {
                "input-riferimento-calcolo": "prezzo",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
            ]))
          : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}